import styled from 'styled-components';

export const StatusButtonMenu = styled.div`
  display: flex;
  width: auto;
  justify-content: space-between;
`;
